import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Footer from "../Components/Footer";
import Menubar from "../Components/Menubar";
import Totop from "../Components/Totop";
import ProductShowcase from "./ProductShowcase";
import "./Rpm.css";
import "../../index.css";
import { MediaQueryContext } from "../../context";
import rpm_img2 from "../../assets/images/03rpm/rpm_img2.svg";
import serviceimg1 from "../../assets/images/03rpm/service1_card.png";
import serviceimg2 from "../../assets/images/03rpm/service2_card.png";
import larsCareImg from "../../assets/images/03rpm/lars_care.svg";

/* Why We Need RPM 카드용 선 아이콘 (카드 스타일에 맞춰 직접 그림) */
const BOX_ICONS = {
  efficiency: ["M4 19h16", "M7 16V9", "M12 16V5", "M17 16v-4"],
  time: ["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", "M12 7v5l3 2"],
  results: ["M4 13a8 8 0 0 1 16 0", "M12 13l4-4", "M4 19h16"],
  cost: ["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", "M15 9.5a3 3 0 0 0-3-1.5c-1.7 0-3 .9-3 2s1.3 2 3 2 3 .9 3 2-1.3 2-3 2a3 3 0 0 1-3-1.5", "M12 6.5v11"],
};

const BoxIcon = ({ name }) => (
  <svg
    className="rpm-boxicon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {BOX_ICONS[name].map((d, i) => (
      <path key={i} d={d} />
    ))}
  </svg>
);

const renderMultiline = (text) =>
  text.split("\n").map((line, i, arr) => (
    <React.Fragment key={i}>
      {line}
      {i < arr.length - 1 && <br />}
    </React.Fragment>
  ));

const RpmSolution = (props) => {
  const { mTablet } = useContext(MediaQueryContext);
  const { t } = useTranslation();

  const executeScroll = () => {
    const element = document.getElementById(props.location.hashId);
    const headOffset = mTablet ? 84 : 184;
    const elementPosition = element?.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    executeScroll();
  }, [props.location.update]);

  const boxItems = [
    { key: "efficiency" },
    { key: "time" },
    { key: "results" },
    { key: "cost" },
  ];

  const serviceItems = [
    {
      key: "ostoCare",
      img: serviceimg1,
      site: "https://www.ostocare.co.kr/",
      appStore: "https://apps.apple.com/kr/app/id1619734796",
      play: "https://play.google.com/store/apps/details?id=com.herings.stoma",
      detailKey: "ostoCare",
    },
    { key: "atti", img: serviceimg2, detailKey: "atti", numbered: true },
    { key: "larsCare", img: larsCareImg },
  ];

  return (
    <div id="rpmsolution">
      <Menubar slideIndex={0} />
      <Totop />
      <div className="rpm-main-container">
        <div className="rpm-container1">
          <div className="rpm-section1-text-layout">
            <span className="rpm-section1-maintext">
              {renderMultiline(t("rpm.hero.title"))}
            </span>
            <span className="rpm-section1-subtext ">
              {renderMultiline(t("rpm.hero.subtitle"))}
            </span>
          </div>
        </div>
        <div className="rpm-container2">
          <div>
            <p className="rpm-section2-maintext">
              {t("rpm.what.title")}{" "}
              <span
                style={{
                  fontSize: "clamp(2rem, 2.2vw, 3rem)",
                  color: "#F68C29",
                }}
              >
                R
              </span>
              emote{" "}
              <span
                style={{
                  fontSize: "clamp(2rem, 2.2vw, 3rem)",
                  color: "#F68C29",
                }}
              >
                P
              </span>
              atient{" "}
              <span
                style={{
                  fontSize: "clamp(2rem, 2.2vw, 3rem)",
                  color: "#F68C29",
                }}
              >
                M
              </span>
              onitoring?
            </p>
            <span className="rpm-section2-subtext">{t("rpm.what.body")}</span>
          </div>
          <img src={rpm_img2} alt="rpmImage2" className="rpmImage" />
        </div>
        <div className="rpm-container3">
          <div className="rpm-section3-group-container ">
            {boxItems.map((item, idx) => (
              <div className="rpm-section3-group-box" key={idx}>
                <BoxIcon name={item.key} />
                <div className="rpm-section3-boxtext-layout">
                  <p className="rpm-section3-box-text">
                    {t(`rpm.why.boxes.${item.key}.title`)}
                  </p>
                  <span className="rpm-section3-box-subtext">
                    {renderMultiline(t(`rpm.why.boxes.${item.key}.content`))}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <div className="rpm-section3-text-layout">
            <p className="rpm-section3-maintext">
              {t("rpm.why.title")}{" "}
              <span
                style={{
                  fontSize: "clamp(2rem, 2.5vw, 3rem)",
                  color: "#F68C29",
                }}
              >
                {t("rpm.why.highlight")}
              </span>
              <span style={{ fontSize: "clamp(2rem, 2.5vw, 3rem)" }}>?</span>
            </p>
            <span className="rpm-section3-subtext">{t("rpm.why.body")}</span>
          </div>
        </div>
        <div className="rpm-section4-layout-bg">
          <div className="rpm-section4-layout">
            <div>
              <p className="rpm-section4-maintext ">
                {t("rpm.services.title")}{" "}
                <span
                  style={{
                    color: "#F68C29",
                  }}
                >
                  {t("rpm.services.highlight")}
                </span>{" "}
                {t("rpm.services.titleAfter")}
              </p>
            </div>
            <ProductShowcase ns="rpm" items={serviceItems} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RpmSolution;
